import api from '@/api/axios';

const state = {
    createAccount: null,
    etapaCadastro: null,
    abrirModalChamado: false
};

const encodedCredentials = btoa('sat@sat:sat23!');

const getters = {

    GET_ABRIR_MODAL_CHAMADO: state => state.abrirModalChamado,

};

const mutations = {
    SET_ABRIR_MODAL_CHAMADO: (state, abrirModalChamado) => {
        state.abrirModalChamado = abrirModalChamado
    },
   
};

const actions = {
   
    FETCH_CONSULTA_CHAMADOS: async ({ commit }) => {
        const { data } = await api.get(`/Disclaimer`, {
            headers: { 'Authorization': `Basic ${encodedCredentials}` }
          });
          console.log(data.data);
        commit('SET_LISTA_DISCLAIMER', data.data)
    },
    //Fim ficha PF
    
};

export default {
    state,
    getters,
    mutations,
    actions
}
